// Layout
const dashboardLayout = () =>
  import('@/layouts/HospitalLayout/DashboardLayout/dashboardLayout.vue')

const support = () => import('./views/index')

// start Routes
export default [
  {
    path: '/doctor/support',
    component: dashboardLayout,
    children: [
      {
        path: '',
        name: 'doctorSupport',
        meta: {
          name: 'doctorSupport',
          parentName: 'marketplace',
          userType: '',
          permission: '',
          role: 'veterinary.doctor'
        },
        component: support
      }
    ]
  }
]
